// Module
var code = "<div class=\"im-cwheader\"> <div class=\"im-contact-info\"> <span class=\"im-contact-name\"></span><span class=\"im-contact-num\"></span> <span class=\"im-contact-type\"></span> </div> <div class=\"im-cwheader-plugins\"> </div> </div> ";
// Exports
module.exports = code;